import { Group } from '@mantine/core';
import type React from 'react';

type RightProps = React.ComponentProps<typeof Group>;

/**
 * Shorthand right-aligned `Group`, in the same vein as `Center`.
 * Accepts all props supported by `Group`.
 */

export const Right = ({ children, ...componentProps }: RightProps) => (
  <Group justify="flex-end" {...componentProps}>
    {children}
  </Group>
);
